/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
import { GetStaticPaths, GetStaticProps } from 'next';
import api from '@/services/api';
import PostModel from '@/models/post';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Link from 'next/link';
import Image from 'next/image';
import Head from 'next/head';
import { ContainerSearch, NoResults } from '@/styles/pages/blog/';
import { Button } from '@/components/Button/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useCallback, useEffect, useState } from 'react';
import NavCategory from '@/components/NavCategory';
import Loading from '@/components/Loading';
import SideNav from '@/components/SideNav';

interface PostsProps {
  posts: PostModel[];
  totalPages: number;
  page: number;
  category: any;
}

// const Category: React.FC<PostsProps> = ({ posts }) => <Posts posts={posts} />;

const CategoryBlog: React.FC<PostsProps> = ({ posts, category }) => {
  return (
    <>
      <Head>
        <title>Categoria | Cloudez Blog</title>
      </Head>
  
      <SideNav />
      <ContainerSearch>
        <div className="container-results">
          <div className="steps-result_slug">
            <a style={{ marginRight: '7px' }} href="/br/blog">
              <Image
                priority
                src="/home.png"
                width={13}
                height={13}
                alt="home"
              />
            </a>
            <Image
              priority
              src="/arrow-right.png"
              width={8}
              height={16}
              alt="arrow"
            />
            <div style={{ marginLeft: '0.5rem' }}>{category?.name}</div>
          </div>

          <div className="title-search">
            <h1>{category?.name}</h1>
          </div>

          {posts?.map((posts) => {
            let excerptCategory = posts.excerpt.rendered;
            if (excerptCategory?.length > 110) {
              excerptCategory = `${excerptCategory?.substring(0, 110)}...`;
            }
            let titleCategory = posts.title.rendered;
            if (titleCategory?.length > 60) {
              titleCategory = `${titleCategory?.substring(0, 60)}...`;
            }
            return (
              <div key={posts.slug} className="posts-content">
                <a href={`/br/blog/${posts.slug}`}>
                  <Image
                    priority
                    src={
                      posts._embedded?.['wp:featuredmedia'][0]?.source_url
                    }
                    width="380px"
                    height="292.78px"
                    alt={
                      posts._embedded?.['wp:featuredmedia'][0]?.alt_text
                    }
                    objectFit="cover"
                  />
                </a>
                <div className="category-information">
                  <h3>{posts._embedded?.['wp:term'][0][0]?.name}</h3>

                  <a href={`/br/blog/${posts.slug}`}>
                    <h2
                      dangerouslySetInnerHTML={{
                        __html: titleCategory
                      }}
                    />

                    <div
                      dangerouslySetInnerHTML={{
                        __html: excerptCategory
                      }}
                    />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </ContainerSearch>
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const { data } = await api.get('/categories');

  const paths = data?.map((cat) => ({
    params: {
      slug: cat.slug,
      id: cat.id
    },
    locale: 'br'
  }));

  return {
    paths,
    fallback: true
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context;
  const { slug } = context.params;

  if (locale !== 'br') {
    return {
      notFound: true
    };
  }

  const { data: categories } = await api.get('/categories');

  const [category] = categories.filter((cat) => cat.slug === slug);

  const { data } = await api.get('/posts', {
    params: {
      categories: category?.id || null,
      _embed: 1,
      per_page: 10,
      page: 1
    }
  });

  return {
    props: {
      ...(await serverSideTranslations(locale.toString())),
      posts: data,
      category
    },
    revalidate: 10
  };
};

export default CategoryBlog;
